export default "__VITE_ASSET__vNV2JBYm__"